import React from 'react'
import { Box, Typography, Grid, Container } from '@mui/material'
import { Form_Ai_data } from '../../Data/Form_Ai_Data'
import './FormAi.css'

const From_Ai = () => {
    return (
        <Container>
            <Box  className='FormAi' id="powerform">
                <Typography variant="h4" color="initial" fontWeight={600} >Powered by Form-AI</Typography>
                <Typography variant="h6" color='secondary' sx={{ marginTop: '17px' }}>Our AI powered Insurance Algorithm that supports brokers and clients.</Typography>
                <Grid container spacing={4} sx={{ paddingTop: '50px', }}>
                    {
                        Form_Ai_data.map((data) => {
                            return (
                                <Grid item  xs={12} sm={6} md={6} lg={3}>
                                    <Box sx={{border: '2px solid #D9DADB', minHeight: '350px',backgroundColor:'white', borderRadius: '10px', padding: ' 30px 30px', textAlign: 'left' }}>
                                        <img src={data.Image} alt="" />
                                        <Typography variant="h5" color="initial" fontWeight={600}>{data.title}</Typography>
                                        <Typography variant="body1" color='secondary' sx={{ marginTop: '17px' }}>{data.desc}</Typography>
                                    </Box>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Box>
        </Container>
    )
}

export default From_Ai